import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// get locale from page, with user window as fallback
const getLocale = () => {
  // for demo i removed so i can show diffrent language in my browser changes aria label
  // document.documentElement.lang doesn't change lang in storybook
  return (window.navigator.userLanguage || window.navigator.language).substring(0, 2)
}

function loadLocaleMessages () {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: getLocale() || process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
